import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import Button from 'syngenta-react-components/dist/components/Button'

const SurveyCode = () => {
  const [apiResponse, setApiResponse] = useState(null)
  const [isCopied, setIsCopied] = useState(false)
  const [loader, setLoader] = useState(false)
  const [apiErrorMsg, setApiErrorMsg] = useState('')
  const [apiError, setApiError] = useState(false)

  const ADDRESS = process.env.REACT_APP_API_URL

  const handleCopy = () => {
    const textarea = document.createElement('textarea')
    textarea.value = apiResponse?.code
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    const copiedText = apiResponse?.code
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 2000)
    return copiedText
  }


  const fetchData =  useCallback(async () => {
    try {
      setLoader(true)
      const response = await axios.get(`${ADDRESS}/platform-integrations/v1/survey-code?generate_new_survey_code=true`)
      setApiResponse(response?.data)
      setLoader(false)
    } catch (error) {
      setLoader(false)
      setApiErrorMsg(error?.response?.data?.errors[0]?.message)
      setApiError(true)
      console.error('Error fetching data:', error)
    }
  },[ADDRESS])

  function capitalizeFirstLetter(sentence) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1)
  }  

  useEffect(() => {
    fetchData()
  }, [ADDRESS, fetchData])

  return (
    <div className='df fxdrc jcc aic mt40'>

      {loader ?  <div className='loader'/> :
        !apiError ?
          <>
            {apiResponse &&
          <div style={{ margin:'0 auto', display: 'block' }}>
            <p className='tal p0 mb10'>Survey Code:</p>
            <div className='df aic jcsb' style={{ paddingBottom:'5px' }}>
              <textarea
                value={apiResponse && apiResponse.code}
                onChange={e => setApiResponse(e.target.value)}
                rows={1}
                cols={30}
                readOnly={true}
                style={{ backgroundColor:'rgba(16,20,24,0.8)', border: 0, padding: '10px', color: '#ffffff' }}
              />
              <Button styleType='success' customClassName="mb0 ml10" onClick={handleCopy}>
                {isCopied ? 'Copied!' : 'Copy code'}
              </Button>
            </div>
            
          </div> 
            }
          </>
          : apiError ? 
            <>
              <h1 className='m0'>Whoops!</h1>
              <p className='m0'>{apiErrorMsg ? capitalizeFirstLetter(apiErrorMsg) : 'Something went wrong.'}</p>
            </> : 
            <p>Code sent successfully.</p>
      }
    </div>
  )
}

export default SurveyCode
